/**
 * El recorrido del mensaje (fase 5c, diseño `Resultado.dc.html` y `Estadisticas.dc.html`): enviados, les llegó,
 * hicieron clic (mail) o lo leyeron y respondieron (WhatsApp), compraron y usaron el cupón, con lo que dice. Lo usan el
 * detalle de cada grupo del Resultado y Estadísticas (por canal).
 */

import { lecturaDelRecorrido, pasosDelRecorrido } from "../logic/resultado";
import type { Recorrido } from "../types";

export function RecorridoDelMensaje({ recorrido, canal, titulo, testId }: { recorrido: Recorrido; canal: "whatsapp" | "email"; titulo?: string; testId?: string }) {
  const lectura = lecturaDelRecorrido(recorrido, canal);
  return (
    <div className="space-y-3" data-testid={testId}>
      {titulo && <h3 className="text-base font-semibold text-slate-900">{titulo}</h3>}
      <ol className="flex flex-wrap gap-2.5">
        {pasosDelRecorrido(recorrido, canal).map((p) => (
          <li key={p.titulo} className="flex min-w-[130px] flex-1 flex-col gap-1 rounded-xl bg-slate-50 p-3.5">
            <span className="text-sm text-slate-500">{p.titulo}</span>
            <span className="text-xl font-bold text-slate-900">
              {p.valor}
              {p.pct && <span className="ml-1.5 text-sm font-medium text-slate-500">· {p.pct}</span>}
            </span>
            <span className="h-1.5 overflow-hidden rounded-full bg-slate-200" aria-hidden="true">
              <span className="block h-full rounded-full bg-violet-600" style={{ width: p.ancho }} />
            </span>
          </li>
        ))}
      </ol>
      {lectura.map((t) => (
        <p key={t} className="rounded-xl bg-violet-50 px-4 py-3 text-sm text-violet-900">
          {t}
        </p>
      ))}
      {canal === "email" && <p className="text-xs text-slate-500">No mostramos aperturas: los celulares las marcan solas.</p>}
    </div>
  );
}
